import { render, staticRenderFns } from "./ProjectEditor.yaml?vue&type=template&id=16ac2a86&component"
import script from "./ProjectEditor.yaml?vue&type=script&lang=ts&component"
export * from "./ProjectEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports